import React from 'react';

const Loading: React.FC = () => <div>Loading ..</div>;

export default Loading;
